const decodeEntities = (value) => String(value || '')
  .replace(/&#x([0-9a-f]+);/gi, (_, hex) => String.fromCodePoint(parseInt(hex, 16)))
  .replace(/&#([0-9]+);/g, (_, decimal) => String.fromCodePoint(parseInt(decimal, 10)))
  .replace(/&nbsp;/gi, ' ').replace(/&amp;/gi, '&').replace(/&quot;/gi, '"')
  .replace(/&apos;|&#39;/gi, "'").replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');

const plainText = (html) => decodeEntities(String(html || ''))
  .replace(/<script[\s\S]*?<\/script>/gi, ' ').replace(/<style[\s\S]*?<\/style>/gi, ' ')
  .replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();

const slugify = (value) => plainText(value).toLowerCase().normalize('NFKD')
  .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';

export const enrichArticleHtml = (html) => {
  const usedIds = new Set(); const toc = [];
  const enrichedHtml = String(html || '').replace(/<h2\b([^>]*)>([\s\S]*?)<\/h2>/gi, (_match, attributes, content) => {
    const existingId = attributes.match(/\bid=["']([^"']+)["']/i)?.[1]; const baseId = existingId || slugify(content);
    let id = baseId; let suffix = 2; while (usedIds.has(id)) { id = `${baseId}-${suffix}`; suffix += 1; }
    usedIds.add(id); toc.push({ id, text: plainText(content) });
    return `<h2${attributes.replace(/\s*\bid=["'][^"']+["']/i, '')} id="${id}">${content}</h2>`;
  });
  const words = plainText(enrichedHtml).split(/\s+/).filter(Boolean).length;
  return { html: enrichedHtml, toc, words, readMinutes: Math.max(1, Math.ceil(words / 230)) };
};
